module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_04_1400.838201d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_04_1400.jpg
// module id = 347
// module chunks = 0